import React from "react";

import { MarketplacePage as MarketplacePageEnum } from "./constants/marketplace_page";
import { MarketplaceContextProvider } from "./contexts/marketplace_context";
import { MarketplacePage } from "./marketplace_page";

type MarketplaceControllerProps = {
  page: MarketplacePageEnum;
};

export const MarketplaceController = ({ page }: MarketplaceControllerProps): JSX.Element => (
  <MarketplaceContextProvider>
    <MarketplacePage page={page} />
  </MarketplaceContextProvider>
);
